import { render, staticRenderFns } from "./ValidationStatus.vue?vue&type=template&id=42809111&scoped=true&"
import script from "./ValidationStatus.vue?vue&type=script&lang=js&"
export * from "./ValidationStatus.vue?vue&type=script&lang=js&"
import style0 from "./validationStatus.scss?vue&type=style&index=0&id=42809111&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42809111",
  null
  
)

export default component.exports